// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__ButtonPrimaryMobile from "../../components/html/ButtonPrimaryMobile.js";
import * as Buhta_cabinet__PdfCanvas from "./PdfCanvas.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function SignFlowMobile(Props) {
  let code = Props.code;
  let doc = Props.doc;
  const match = React.useState(function () {
    return false;
  });
  const setDropdownVisible = match[1];
  const dropdownVisible = match[0];
  const match$1 = React.useState(function () {
    return "100vh";
  });
  const setScreenHeight = match$1[1];
  React.useEffect((function () {
    const availHeight = window.innerHeight;
    Curry._1(setScreenHeight, (function (param) {
      return String(availHeight) + "px";
    }));
  }), []);
  const previewUrl = Belt__Belt_Option.getExn(doc.document).preview_url;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6",
            alt: "docs",
            src: StaticAsset.src("/static/icons/docs-white-24.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.H4.make, {
            className: "text-white",
            children: "Акт выполненных работ"
          })
        ],
        className: "bg-black p-4 flex gap-3 items-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                children: "Документ 4001"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                  className: "text-default-gray",
                  children: "Ждем подписи получателя"
                }),
                className: "px-2 py-0.5 bg-gray-pale rounded-3xl inline-block"
              })
            ],
            className: "space-y-2"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              className: Cn.fromList({
                hd: "w-5 h-5 transition-transform",
                tl: {
                  hd: dropdownVisible ? "" : "-rotate-90",
                  tl: /* [] */ 0
                }
              }),
              alt: "print",
              src: StaticAsset.src("/static/icons/dropdown-black-20.svg")
            })
          })
        ],
        className: "bg-white px-4 py-2.5 flex justify-between items-center text-left",
        onClick: (function (param) {
          Curry._1(setDropdownVisible, (function (param) {
            return !dropdownVisible;
          }));
        })
      }),
      JsxRuntime.jsx("div", {
        className: Cn.fromList({
          hd: "absolute top-[124px] left-0 bottom-0 bg-white border-t border-gray-main w-full px-4 py-6 z-10 overflow-auto",
          tl: {
            hd: dropdownVisible ? "" : "hidden",
            tl: /* [] */ 0
          }
        })
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_cabinet__PdfCanvas.make, {
          multi: false,
          hash: doc.hash,
          previewUrl: previewUrl,
          orientation: Belt__Belt_Option.getExn(doc.document).orientation
        }),
        className: "h-full flex p-4 w-full overflow-auto"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_cabinet__ButtonPrimaryMobile.make, {
          title: "Подписать в eGov Mobile",
          icon: StaticAsset.src("/static/icons/phone-white-20.svg"),
          href: "https://mgovsign.page.link/?link=https://buhta.com/mgovSign/" + code + "&apn=kz.mobile.mgov&isi=1476128386&ibi=kz.egov.mobile"
        }),
        className: "w-full px-4 pb-4 absolute bottom-0"
      })
    ],
    className: "bg-gray-pale flex flex-col relative",
    style: {
      height: match$1[0]
    }
  });
}

const make = SignFlowMobile;

export {
  make,
}
/* Buhta_cabinet__ButtonPrimaryMobile Not a pure module */
